import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQuerySimplePassengerData =
  Content.Components['SimplePassengerModuleDto'];

interface UseQuerySimplePassengerOptions {
  enabled?: boolean;
  initialData?: UseQuerySimplePassengerData;
  parameters: Content.Components['IBookingHeadlessParameters'] & {
    id: string;
    pageId: string;
  };
}

const useQuerySimplePassenger = ({
  enabled = true,
  initialData,
  parameters,
}: UseQuerySimplePassengerOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQuerySimplePassengerData>(
    [QueryId.SIMPLE_PASSENGER, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/simple-passenger';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQuerySimplePassenger', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQuerySimplePassenger;
